<template>
  <q-btn unelevated color="back-primary" text-color="black" size="md" rounded>
    <slot />
  </q-btn>
</template>
